module.exports = "/v2/pages/dashboard/dist/2dd3a15f5f8742a4f2cef40cf3e57481.svg";